"use client";

import React from "react";
import Image from "next/image";
import Link from "next/link";

const WhyChooseSmile4Me: React.FC = () => {
  return (
    <section className="w-full py-6 sm:py-8 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
        <h2
          className="
            text-2xl sm:text-3xl font-semibold text-gray-800 text-center
            pb-6 after:content-[''] after:block after:w-[200px] after:h-[3px] after:mx-auto after:mt-2
            after:bg-[linear-gradient(to_right,#AE7D2F_0%,#ECD05B_50%,#AE7D2F_100%)]
          "
        >
          Why Choose Smile4Me Dental Care?
        </h2>
        <div className="relative w-full h-[300px] md:h-[500px] my-8 rounded-lg overflow-hidden shadow-lg">
          <Image
            src="/images/photo-man-in-suit-standing-beside-smile4me-wall-logo-discussing-full-mouth-dental-implants-astoria-at-dental-office.jpg"
            alt="photo-man-in-suit-standing-beside-smile4me-wall-logo-discussing-full-mouth-dental-implants-astoria-at-dental-office"
            fill
            className="object-cover"
            sizes="(max-width: 768px) 100vw, 50vw"
          />
        </div>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          Dr. Khaimov graduated from New York University&apos;s College of
          Dentistry in 2019. Since then, he has built deep expertise in
          implant dentistry across multiple New York City practices. As a
          reliable{" "}
          <Link
            href="https://maps.google.com/maps?cid=8192593597492375843"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-gradient-to-r from-[#AE7D2F] via-[#ECD05B] to-[#AE7D2F] bg-clip-text text-transparent hover:underline transition-all duration-300 ease-in-out"
          >
            dentist in Astoria
          </Link>
          , we recommend only what will make a lasting difference; never
          treatments that don&apos;t fit your situation.
        </p>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
          Our implant services include:
        </p>
        <ul className="list-disc list-inside space-y-3 text-gray-700 text-base sm:text-lg leading-relaxed">
          <li>
            <Link
              href="/services/all-on-4/"
              className="inline-block bg-gradient-to-r from-[#AE7D2F] via-[#ECD05B] to-[#AE7D2F] bg-clip-text text-transparent hover:underline transition-all duration-300 ease-in-out font-semibold"
            >
              All-on-4® Implants
            </Link>
            : Full-arch restoration with four implants per arch
          </li>
          <li>
            <strong>All-on-6® Implants:</strong> Enhanced stability for
            patients with greater bone volume
          </li>
          <li>
            <strong>Dental Implant Restorations:</strong> Crowns and
            prosthetics for existing implants
          </li>
          <li>
            <strong>Same-Day Dental Implants:</strong> Immediate placement for
            qualifying patients
          </li>
        </ul>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          For urgent dental needs, our{" "}
          <Link
            href="/services/emergency-treatment/"
            className="inline-block bg-gradient-to-r from-[#AE7D2F] via-[#ECD05B] to-[#AE7D2F] bg-clip-text text-transparent hover:underline transition-all duration-300 ease-in-out"
          >
            emergency dentist in Astoria
          </Link>{" "}
          keeps your treatment on track without delays.
        </p>
      </div>
    </section>
  );
};

export default WhyChooseSmile4Me;
